module.exports = `<!DOCTYPE html>
<html lang="en">

<head>
  <meta charset="utf-8" />
  <meta http-equiv="X-UA-Compatible" content="IE=edge" />
  <meta name="viewport" content="width=device-width, initial-scale=1, shrink-to-fit=no" />
  <meta name="description" content />
  <meta name="author" content />
  <title>Home - OM Sandbox</title>
  <link href="home/css/style.css" />
  <link href="home/css/styles.css" rel="stylesheet" />
  <link rel="stylesheet" href="home/css/aos.css" />
  <link rel="icon" type="image/x-icon" href="https://themes.startbootstrap.com/sb-ui-kit-pro/assets/img/favicon.png" />
  <script data-search-pseudo-elements defer
    src="home/js/all.min.js" crossorigin="anonymous"></script>
  <script src="https://cdnjs.cloudflare.com/ajax/libs/feather-icons/4.24.1/feather.min.js" crossorigin="anonymous">
  </script>
</head>

<body>
  <div id="layoutDefault">
    <div id="layoutDefault_content">
      <main>
        <nav class="navbar navbar-marketing navbar-expand-lg bg-primary navbar-dark fixed-top">
          <div class="container">
            <a class="navbar-brand text-white" href="/dashboard">OM Sandbox</a><button class="navbar-toggler"
              type="button" data-toggle="collapse" data-target="#navbarSupportedContent"
              aria-controls="navbarSupportedContent" aria-expanded="false" aria-label="Toggle navigation"><i
                data-feather="menu"></i></button>
            <div class="collapse navbar-collapse" id="navbarSupportedContent">
              <ul class="navbar-nav ml-auto mr-lg-5">
                <li class="nav-item"><a class="nav-link" href="#">Home </a></li>
                <li class="nav-item"><a class="nav-link" href="/policy">Policy</a></li>
                <li class="nav-item"><a class="nav-link" href="/pricing">Pricing </a></li>
                <li class="nav-item"><a class="nav-link" href="/contact">Contact </a></li>
              </ul>
              <a class="btn-teal btn rounded-pill px-4 ml-lg-4" href="/login">Login<i class="fas fa-arrow-right ml-1"></i></a>
              <a style="display: none" class="btn-yellow btn rounded-pill px-4 ml-lg-4" href="/admin/login">Login by Password<i class="fas fa-arrow-right ml-1"></i></a>
            </div>
          </div>
        </nav>
        <header class="page-header page-header-dark bg-gradient-primary-to-secondary">
          <div class="page-header-content pt-10">
            <div class="container">
              <div class="row align-items-center">
                <div class="col-lg-6">
                  <h1 class="page-header-title">Automate and grow your e&#8209;commerce business with ease!</h1>
                  <p class="page-header-text mb-5">OM Sandbox gives you the freedom to manage your stores business like
                    a pro.</p>
                  <a class="btn btn-teal btn-marketing rounded-pill lift lift-sm" href="/login">Sign Up today<i
                      class="fas fa-arrow-right ml-1"></i></a>
                </div>
                <div class="col-lg-6 d-none d-lg-block"><img class="img-fluid" src="home/images/drawkit-content-man-color.svg" /></div>
              </div>
            </div>
          </div>
          <div class="svg-border-rounded text-white">
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 144.54 17.34" preserveAspectRatio="none"
              fill="currentColor">
              <path d="M144.54,17.34H0V0H144.54ZM0,0S32.36,17.34,72.27,17.34,144.54,0,144.54,0" /></svg>
          </div>
        </header>
        <section class="bg-white py-10">
          <div class="container">
            <div class="row justify-content-center">
              <div class="col-lg-8">
                <div class="text-center mb-10">
                  <h2>The Features</h2>
                 <p class="lead">Sync your multi-platform business with our exclusive tools. List products faster than ever before. Design beautiful templates, manage your orders, messages, and more.</p>
                </div>
              </div>
            </div>
            <div class="row text-center">
              <div class="col-lg-4 mb-5">
                <h6 class="mb-3">Design</h6>
                <div>Brand new to our arsenal are thousands of professionally created templates for your business and brand. Revolutionizing your company has never been so simple.</div>
              </div>
              <div class="col-lg-4 mb-5">
                <h6 class="mb-3">List</h6>
                <div>Our Amazon listing software services are tried and true. With more than a decade of loyal users, deep research and technological advancements going into our interface, your business is sure to see success.</div>
              </div>
              <div class="col-lg-4 mb-5">
                <h6 class="mb-3">Import, Export & Sync</h6>
                <div>Grow your sales beyond Amazon or BigCommerce. Keep your inventory & orders in sync with ease. Create new ASINs on Amazon and keep your eBay listings in sync with your online store.</div>
              </div>
            </div>
          </div>
          <div class="svg-border-rounded text-light">
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 144.54 17.34" preserveAspectRatio="none"
              fill="currentColor">
              <path d="M144.54,17.34H0V0H144.54ZM0,0S32.36,17.34,72.27,17.34,144.54,0,144.54,0" /></svg>
          </div>
        </section>
        <section class="bg-light py-10">
          <div class="container">
            <div class="row justify-content-center">
              <div class="col-lg-8">
                <div class="text-center mb-10">
                  <h2>Listings Management</h2>
                  <p class="lead">Sync your multi-platform business with our exclusive tools. List to Amazon faster than ever before. Design beautiful templates, manage your orders, messages and more.</p>
                </div>
              </div>
            </div>
            <div class="row">
              <img src="home/images/Listings.png" class="col-lg-12 float-left"/>
            </div>
          </div>
          <div class="svg-border-rounded text-white">
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 144.54 17.34" preserveAspectRatio="none"
              fill="currentColor">
              <path d="M144.54,17.34H0V0H144.54ZM0,0S32.36,17.34,72.27,17.34,144.54,0,144.54,0" /></svg>
          </div>
        </section>
        <section class="bg-white py-10">
          <div class="container">
            <div class="row justify-content-center">
              <div class="col-lg-8">
                <div class="text-center mb-10">
                  <h2>Our Supported Platforms</h2>
                </div>
              </div>
            </div>
            <div class="row text-center">
              <div class="col-lg-4 mb-5">
                <img class="img-fluid rounded-lg"
                    src="home/images/ebay.svg" />
              </div>
              <div class="col-lg-4 mb-5">
                <img class="img-fluid rounded-lg"
                src="home/images/amazon.svg" />
              </div>
              <div class="col-lg-4 mb-5">
                <img class="img-fluid rounded-lg"
                  src="/home/images/etsy.jpg" />
              </div>
              <div class="col-lg-12 mb-12">
                At OM Sandbox, we build smart, reliable solutions that help Amazon sellers automate and grow their businesses. Our tools streamline inventory, listings, and order management—giving sellers more time to focus on scaling.
              </div>
            </div>
          </div>
          <div class="svg-border-rounded text-light">
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 144.54 17.34" preserveAspectRatio="none"
              fill="currentColor">
              <path d="M144.54,17.34H0V0H144.54ZM0,0S32.36,17.34,72.27,17.34,144.54,0,144.54,0" /></svg>
          </div>
        </section>
      </main>
    </div>
    <div id="layoutDefault_footer">
      <footer class="footer pt-10 pb-5 mt-auto bg-white footer-light">
        <div class="container">
          <div class="row">
            <div class="col-lg-3">
              <div class="footer-brand">OM Sandbox</div>
            </div>
            <div class="col-lg-9">
              <div class="row">
                <div class="col-lg-3 col-md-6 mb-5 mb-lg-0">
                  <div class="text-uppercase-expanded text-xs mb-4">Features</div>
                  <ul class="list-unstyled mb-0">
                    <li class="mb-2"><a href="javascript:void(0);">Design template</a></li>
                    <li class="mb-2"><a href="javascript:void(0);">Business</a></li>
                    <li class="mb-2"><a href="javascript:void(0);">Developer</a></li>
                  </ul>
                </div>
                <div class="col-lg-3 col-md-6 mb-5 mb-lg-0">
                  <div class="text-uppercase-expanded text-xs mb-4">Product & Services</div>
                  <ul class="list-unstyled mb-0">
                    <li class="mb-2"><a href="javascript:void(0);">Services</a></li>
                    <li class="mb-2"><a href="javascript:void(0);">Changelog</a></li>
                    <li class="mb-2"><a href="javascript:void(0);">Theme Customizer</a></li>
                    <li><a href="javascript:void(0);">UI Kit</a></li>
                  </ul>
                </div>
                <div class="col-lg-3 col-md-6 mb-5 mb-md-0">
                  <div class="text-uppercase-expanded text-xs mb-4">Help &  Support</div>
                  <ul class="list-unstyled mb-0">
                    <li class="mb-2"><a href="javascript:void(0);">Support Center</a></li>
                    <li class="mb-2"><a href="javascript:void(0);">FAQ</a></li>
                    <li class="mb-2"><a href="javascript:void(0);">Terms & Conditions</a></li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
          <hr class="my-5" />
          <div class="row align-items-center">
            <div class="col-md-6 small">Copyright &#xA9; OM Sandbox 2026 - Version 1.0</div>
            <div class="col-md-6 text-md-right small">
              <a href="javascript:void(0);">Privacy Policy</a>
              &#xB7;
              <a href="javascript:void(0);">Terms &amp; Conditions</a>
            </div>
          </div>
        </div>
      </footer>
    </div>
  </div>
  <script src="https://code.jquery.com/jquery-3.4.1.min.js" crossorigin="anonymous"></script>
  <script src="https://stackpath.bootstrapcdn.com/bootstrap/4.3.1/js/bootstrap.bundle.min.js" crossorigin="anonymous">
  </script>
  <script src="home/js/scripts.js"></script>
  <script src="home/js/aos.js"></script>
  <script>
    AOS.init({
                disable: 'mobile',
                duration: 600,
                once: true
            });
  </script>

  <script src="home/js/sb-customizer.js"></script>
  <sb-customizer project="sb-ui-kit-pro"></sb-customizer>
</body>

</html>
`;
